import { useTranslation } from 'react-i18next';

import { InfoSection, InfoSectionWrapper, StyledTitle } from 'components/containers/InfoSection';

export const ConfirmEmailError = () => {
  const { t } = useTranslation('account');

  return (
    <InfoSectionWrapper>
      <InfoSection onSuccess={false} />
      <StyledTitle>{t('email-confirm-error')}</StyledTitle>
    </InfoSectionWrapper>
  );
};
